// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sevenlycard {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}

label {
  font-size: 1.4rem !important;
  font-family: "Poppins", sans-serif !important;
}

.sevenly-btn-gray {
  height: 35px;
  border: 1px solid gray !important;
  color: gray !important;
}

.sevenly-btn-white {
  line-height: 40px !important;
  border-radius: 43px !important;
  background: #ffffff !important;
  color: #222222;
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: 1px !important;
  text-transform: uppercase !important;
}

.sevenly-btn-gray:hover {
  color: white !important;
  background-color: gray !important;
}

.mr-2 {
  margin-right: 2rem !important;
}
.mt-2rem {
  margin-top: 2rem !important;
}
.p-2rem {
  padding: 2rem !important;
}

.text-right {
  text-align: right;
}

.card-header {
  border-bottom: 3px solid #ff000f;
}

.card-header h2 {
  padding: 1rem 2rem 0.5rem 2rem;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #262626;
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
}

.Toastify__toast-body > div,
.Toastify__toast-body {
  font-family: "Poppins", sans-serif !important;
  font-size: 1.4rem !important;
}

.part-card {
  display: inline-block;
  width: 45%;
  min-height: 100px;
  margin: 5px;
  background-color: #172b4d !important;
}

.part-icon {
  min-height: 70px;
  padding: 15px;
  text-align: end;
}

.part-icon > svg {
  width: 40px;
  height: 40px;
}

table > thead > tr > th > span > button > div > div,
table > tr > th > div,
table > tr > th,
table > thead > tr > th {
  font-size: 1.2rem !important;
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
}

table > thead > tr > th > span > button {
  padding: 0 !important;
  text-align: left !important;
}
table > tbody > tr > td,
table > tbody > tr > td > div {
  font-size: 1.5rem !important;
  font-family: "Poppins", sans-serif !important;
}

.assembly-card {
  background-color: #172b4d !important;
  color: #ffffff !important;
}

.MuiAvatar-circular > svg {
  width: 100%;
  height: 50%;
}

.small.sevenly-btn {
  line-height: 25px !important;
  font-size: 12px !important;
}

.small.sevenly-btn-white {
  line-height: 25px !important;
  font-size: 12px !important;
  border: 1px solid gray;
  color: #636363;
}

.mb--12 {
  margin-bottom: -12px;
}

.MuiInputLabel-root.MuiInputLabel-shrink.MuiInputLabel-outlined {
  background-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAAA;EACE;uFACqF;AACvF;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;EAYE,cAAc;EACd,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;;EAEE,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,4BAA4B;EAC5B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;;EAEE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".sevenlycard {\n  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;\n}\n\nlabel {\n  font-size: 1.4rem !important;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.sevenly-btn-gray {\n  height: 35px;\n  border: 1px solid gray !important;\n  color: gray !important;\n}\n\n.sevenly-btn-white {\n  line-height: 40px !important;\n  border-radius: 43px !important;\n  background: #ffffff !important;\n  color: #222222;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  letter-spacing: 1px !important;\n  text-transform: uppercase !important;\n}\n\n.sevenly-btn-gray:hover {\n  color: white !important;\n  background-color: gray !important;\n}\n\n.mr-2 {\n  margin-right: 2rem !important;\n}\n.mt-2rem {\n  margin-top: 2rem !important;\n}\n.p-2rem {\n  padding: 2rem !important;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.card-header {\n  border-bottom: 3px solid #ff000f;\n}\n\n.card-header h2 {\n  padding: 1rem 2rem 0.5rem 2rem;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #262626;\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 600 !important;\n}\n\n.Toastify__toast-body > div,\n.Toastify__toast-body {\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 1.4rem !important;\n}\n\n.part-card {\n  display: inline-block;\n  width: 45%;\n  min-height: 100px;\n  margin: 5px;\n  background-color: #172b4d !important;\n}\n\n.part-icon {\n  min-height: 70px;\n  padding: 15px;\n  text-align: end;\n}\n\n.part-icon > svg {\n  width: 40px;\n  height: 40px;\n}\n\ntable > thead > tr > th > span > button > div > div,\ntable > tr > th > div,\ntable > tr > th,\ntable > thead > tr > th {\n  font-size: 1.2rem !important;\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 600 !important;\n}\n\ntable > thead > tr > th > span > button {\n  padding: 0 !important;\n  text-align: left !important;\n}\ntable > tbody > tr > td,\ntable > tbody > tr > td > div {\n  font-size: 1.5rem !important;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.assembly-card {\n  background-color: #172b4d !important;\n  color: #ffffff !important;\n}\n\n.MuiAvatar-circular > svg {\n  width: 100%;\n  height: 50%;\n}\n\n.small.sevenly-btn {\n  line-height: 25px !important;\n  font-size: 12px !important;\n}\n\n.small.sevenly-btn-white {\n  line-height: 25px !important;\n  font-size: 12px !important;\n  border: 1px solid gray;\n  color: #636363;\n}\n\n.mb--12 {\n  margin-bottom: -12px;\n}\n\n.MuiInputLabel-root.MuiInputLabel-shrink.MuiInputLabel-outlined {\n  background-color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
